import React, { useState, useEffect, useContext } from "react";
import { Typography, IconButton, Tooltip, Stack, Divider } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { getRuta, simpleMessage } from "../../../helpers/Helpers";
import { getToken } from "../../../api/Account";
import { DataContext } from "../../../context/DataContext";
import { getActiveClientsAsync } from "../../../api/Dashboard";

const ClientCount = () => {
  const [activeClients, setActiveClients] = useState(0);
  const { setIsLoading, setIsUnautorized } = useContext(DataContext);
  let ruta = getRuta();
  const token = getToken();
  let navigate = useNavigate();

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const result = await getActiveClientsAsync(token);
      if (!result.statusResponse) {
        setIsLoading(false);
        if (result.error === "Unauthorized") {
          setIsUnautorized(true);
          return;
        }
        simpleMessage(result.error, "error");
        return;
      }

      setIsLoading(false);
      setActiveClients(result.data.result);
    })();
  }, []);

  return (
    <div>
      <Stack
        direction={"row"}
        style={{ padding: 10 }}
        justifyContent="space-between"
        alignItems={"center"}
      >
        <Tooltip title="Ver Clientes">
          <IconButton
            sx={{ border: 1, borderColor: "rgba(255, 206, 86, 1)" }}
            style={{
              width: 100,
              height: 100,
              backgroundColor: "rgba(255, 206, 86, 0.2)",
            }}
            onClick={() => navigate(`${ruta}/clients`)}
          >
            <FontAwesomeIcon
              icon={faUsers}
              style={{
                fontSize: 60,
                color: "rgba(255, 206, 86, 1)",
                opacity: 0.3,
                padding: 10,
              }}
            />
          </IconButton>
        </Tooltip>
        <Typography
          align="right"
          style={{
            color: "rgba(255, 206, 86, 1)",
            fontWeight: 800,
            fontSize: 30,
          }}
          paragraph
        >
          {activeClients}
        </Typography>
      </Stack>
      <Divider />
      <Typography
        variant="subtitle1"
        align="center"
        style={{ color: "rgba(255, 206, 86, 1)", fontSize: 20 }}
      >
        Clientes Activos
      </Typography>
    </div>
  );
};

export default ClientCount;
